export default "__VITE_ASSET__5aa6dab5__"